import icons from '/src/assets/fonts/MaterialCommunityIcons.ttf';
import glyphMap from '/src/assets/glyphmaps/MaterialCommunityIcons.json';
import createIcon from './CreateIcon';

const iconSet = createIcon(glyphMap, 'MaterialCommunity', icons);
export default iconSet;
